import { breakpoint, colors, fontFamily, fontSize, mediaQueryHelper, shorthandHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    fontFamily: fontFamily.body,
    color: colors.jumbo,
    width: '100%',
    margin: 'auto',
    marginBottom: spacing.default,
    border: `1px solid ${colors.mystic}`,
    maxWidth: 1077,
  }),

  hoverEffects: css({
    cursor: 'pointer',
    transition: 'all .2s ease-in-out',

    '&:hover': {
      transform: 'scale(1.025)',
    },

    '.footerButton': {
      transition: 'all .3s ease-in-out',
    },

    '&:hover .footerButton': {
      background: colors.cornflowerBlue,
      color: colors.white,
    },
  }),

  mobileChipWrapper: css({
    margin: '10px 10px 2px 10px',
    display: 'flex',

    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'none',
    },
  }),

  mobileChip: css({
    marginLeft: 'auto',
    display: 'flex',
    fontSize: `${fontSize.small}px !important`,
    padding: shorthandHelper([2, 14]),
  }),

  detailsContainer: css({
    padding: spacing.large,
    paddingTop: 0,

    [mediaQueryHelper(breakpoint.phone)]: {
      paddingTop: spacing.large,
    },
  }),

  roles: css({
    width: '100%',
    paddingBottom: 20,
    paddingTop: 15,

    [mediaQueryHelper(breakpoint.phone)]: {
      width: '50%',
      padding: shorthandHelper([spacing.medium, spacing.large, 0, 0]),
    },
  }),

  skills: css({
    width: '100%',
    padding: 0,

    [mediaQueryHelper(breakpoint.phone)]: {
      width: '50%',
      padding: shorthandHelper([spacing.medium, 0, 0, spacing.large]),
    },
  }),

  flexContainer: css({
    display: 'flex',
    flexDirection: 'column',

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),

  footerContainer: css({
    padding: shorthandHelper([0, spacing.large, spacing.large]),

    [mediaQueryHelper(breakpoint.phone)]: {
      padding: shorthandHelper([spacing.default, spacing.large]),
      borderTop: `1px solid ${colors.mystic}`,
    },
  }),

  footerButton: css({
    display: 'flex',
    margin: 'auto',
    fontSize: fontSize.default,
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
    height: '45px !important',
    borderRadius: '3px',
    border: `1px solid ${colors.cornflowerBlue}`,
    fontFamily: fontFamily.body,
    color: colors.cornflowerBlue,
    lineHeight: 1.4,
    padding: '6px 12px',
    background: 'transparent',
    cursor: 'pointer',

    [mediaQueryHelper(breakpoint.phone)]: {
      marginLeft: 'auto',
      marginRight: 0,
      width: 'auto',
      height: '35px !important',
      fontSize: fontSize.small,
    },
  }),

  noScroll: css({
    overflow: 'hidden',
  }),
}

export default styles
